import { render, staticRenderFns } from "./DefiUnlock.vue?vue&type=template&id=a3c37950&"
import script from "./DefiUnlock.vue?vue&type=script&lang=js&"
export * from "./DefiUnlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports